import { apiClient } from "./client"

import type { Notification } from "@/types"

// PRD-26 §FR-6 — query params drive the bell vs. /notificaciones page
// shapes. Defaults mirror the backend signature.
export interface ListNotificationsParams {
  limit?: number
  unread_only?: boolean
  include_archived?: boolean
}

export const notificationsApi = {
  list: (params?: ListNotificationsParams) =>
    apiClient.get<Notification[]>("/notifications/", { params }).then((r) => r.data),

  unreadCount: () =>
    apiClient.get<{ count: number }>("/notifications/unread-count").then((r) => r.data.count),

  markRead: (id: string) =>
    apiClient.patch<{ ok: true }>(`/notifications/${id}/read`).then((r) => r.data),

  markAllRead: () => apiClient.post<{ ok: true }>(`/notifications/read-all`).then((r) => r.data),

  archive: (id: string) =>
    apiClient.delete<{ ok: true }>(`/notifications/${id}`).then((r) => r.data),
}
